export const EXERCISE_REPETITION_SCOPES = ['total', 'each_side'] as const;

export type ExerciseRepetitionScope = (typeof EXERCISE_REPETITION_SCOPES)[number];

export const DEFAULT_REPETITION_SCOPE: ExerciseRepetitionScope = 'total';

export const EXERCISE_REPETITION_SCOPE_OPTIONS: Array<{ value: ExerciseRepetitionScope; label: string }> = [
  { value: 'total', label: 'Total' },
  { value: 'each_side', label: 'Cada lado' },
];

export const EXERCISE_REPETITION_SCOPE_LABELS: Record<ExerciseRepetitionScope, string> = {
  total: 'Total',
  each_side: 'Cada lado',
};

export const isExerciseRepetitionScope = (value?: string | null): value is ExerciseRepetitionScope => (
  value === 'total' || value === 'each_side'
);

export const normalizeRepetitionScope = (value?: string | null): ExerciseRepetitionScope => {
  const normalizedValue = value?.trim().toLowerCase();

  return isExerciseRepetitionScope(normalizedValue) ? normalizedValue : DEFAULT_REPETITION_SCOPE;
};

export const formatRepetitionsWithScope = (repetitionsLabel: string, scope?: string | null) => {
  const normalizedLabel = repetitionsLabel.trim();

  if (!normalizedLabel || normalizedLabel === '—') {
    return normalizedLabel || '—';
  }

  if (normalizeRepetitionScope(scope) !== 'each_side') {
    return normalizedLabel;
  }

  return `${normalizedLabel} cada lado`;
};
